export const PROJECT_STATUS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  ALL: 'all',
} as const;

export const PROJECT_RELATION = {
  CREATED: 'created',
  ASSIGNED: 'assigned',
  ALL: 'all',
} as const;

export const RATE_TYPES = {
  PROJECT_RATE: 'project',
  USER_RATE: 'user',
  NON_BILLABLE: 'non-billable',
} as const;

export const BUDGET_TYPES = {
  HOUR: 'H',
  MONEY: 'M',
  NONE: '',
} as const;

export const BUDGET_STATUS = {
  ALL: 'all',
  BILLABLE: 'billable',
  NON_BILLABLE: 'non-billable',
} as const;

export const BUDGET_CALCULATION = {
  COMPLETED: 'completed',
  PENDING: 'pending',
} as const;

export const BUDGET_SCOPES = {
  TAG: 'tag',
  PROJECT: 'project',
} as const;

export const BUDGET_INTERVAL = {
  MONTH: 'month',
  WEEK: 'week',
  NONE: null,
} as const;

export const BUDGET_RECURRENCE_END = {
  END_DATE: 'end_date',
  ARCHIVED: 'archived',
} as const;

export const MINIMUM_PROJECTS_ON_DASHBOARD: number = 9;
